import { getKey } from "@smartsheet/cufflink";
/**
 * These are set to match the app-core ClientLogger and GlobalLogManager.
 */
export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
})(LogLevel || (LogLevel = {}));
/**
 * The values in this enum number should map to an entry in ClientEventLookup.java in app-core. Action IDs are in the range 0-99.
 *
 * todo: generate and publish from client event lookup.
 */
export var LogActionId;
(function (LogActionId) {
    LogActionId[LogActionId["OPEN"] = 1] = "OPEN";
    LogActionId[LogActionId["CLOSE"] = 2] = "CLOSE";
    LogActionId[LogActionId["DRAG"] = 5] = "DRAG";
    LogActionId[LogActionId["SUBMIT"] = 15] = "SUBMIT";
    LogActionId[LogActionId["MOUSE_DOWN"] = 20] = "MOUSE_DOWN";
    LogActionId[LogActionId["MOUSE_UP"] = 21] = "MOUSE_UP";
    LogActionId[LogActionId["CLICK"] = 22] = "CLICK";
    LogActionId[LogActionId["DOUBLE_CLICK"] = 23] = "DOUBLE_CLICK";
    LogActionId[LogActionId["CONTEXT_CLICK"] = 24] = "CONTEXT_CLICK";
    LogActionId[LogActionId["MIDDLE_CLICK"] = 29] = "MIDDLE_CLICK";
    LogActionId[LogActionId["KEY_STROKE"] = 32] = "KEY_STROKE";
    LogActionId[LogActionId["COMPLETE"] = 53] = "COMPLETE";
    LogActionId[LogActionId["ERROR"] = 55] = "ERROR";
})(LogActionId || (LogActionId = {}));
/**
 * This service concerns itself with the simple act of communicating log strings to the server.
 *
 */
var LoggingStateService = /** @class */ (function () {
    function LoggingStateService(proxyLogger) {
        var _this = this;
        this.proxyLogger = proxyLogger;
        this.warn = function (message, exception) {
            _this.log(LogLevel.WARN, message, exception);
        };
        this.error = function (message, exception) {
            _this.log(LogLevel.ERROR, message, exception);
        };
        this.log = function (logLevel, message, exception) {
            _this.proxyLogger.log(logLevel, message, exception);
        };
        this.logClientEvent = function (controlType, controlId, actionId) {
            _this.proxyLogger.logClientEvent(controlType, controlId, actionId);
        };
        this.logEventWithoutPrivateInfo = function (objectID, actionID, parm1String, parm1Int, eventMetadata) {
            _this.proxyLogger.logEventWithoutPrivateInfo(objectID, actionID, parm1String, parm1Int, eventMetadata);
        };
    }
    return LoggingStateService;
}());
export { LoggingStateService };
export var loggingStateServiceKey = getKey("loggingStateService", LoggingStateService);
//# sourceMappingURL=LoggingStateService.js.map